import * as React from 'react';
import infoCircle from 'src/assets/images/info-circle.png'
import { Tooltip } from 'src/component/Tooltip';
import { useCartStore } from 'src/hooks/cart';
import { useEffect } from 'react';
import { isNumber } from 'underscore';
import Helper from 'src/support/Helper';
import QuoteCartShippingDetail from 'src/pages/QuoteCart/QuoteCartRightContent/QuoteCartShippingDetail';
import Constants from 'src/support/Constants';
import { useState } from 'react';
import { useOrderStore } from 'src/hooks/order';
import CartSummary from 'src/pages/CartSummary';
import getSymbolFromCurrency from 'currency-symbol-map';
import ReusableDiv from 'src/support/ReusableDiv';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import { __remove, __set } from 'src/store/axios_indicator';

const CheckoutTotal = (props) => {
    const [{ CART_DATA, CART_SHIPPING_ADDRESS_ID }, { get_cart_list_subtotal, get_cart_quote_number }, { }] = useCartStore();
    const [{ place_order_item_list }, { }, { }] = useOrderStore();
    const quoteNumber = get_cart_quote_number();
    const [subTotal, setSubTotal] = useState(0)
    const [totalItems, setTotalItems] = useState(0)
    const currency = (place_order_item_list && place_order_item_list.length > 0) ? place_order_item_list[0].currency : window.mct;
    const symbol = (place_order_item_list && place_order_item_list.length > 0) ? getSymbolFromCurrency(place_order_item_list[0].currency) : window.mcs;
    const [__check] = useAxiosIndicatorCheck();

    useEffect(() => {

        if (place_order_item_list && place_order_item_list.length > 0) {
            let total = 0;
            place_order_item_list.map((v) => (total = total + v.subtotal));
            setTotalItems(place_order_item_list.length)
            setSubTotal(total)
        } else {
            setSubTotal(get_cart_list_subtotal(CART_DATA))
            setTotalItems(CART_DATA?.length)
        }

    }, [CART_DATA, place_order_item_list]);

    return (
        <>
            <div className="checkout-total mt-4">
                {(quoteNumber && Object.entries(place_order_item_list).length === 0) ?
                    <QuoteCartShippingDetail summaryFor={Constants.systemModules.CHECKOUT} /> :
                    <>
                        {__check(['CART_API_CALL', 'VIEW_CART_API_CALL']).render}
                        {!__check(['CART_API_CALL', 'VIEW_CART_API_CALL']).status &&

                            <>
                                <div className="p-15">
                                    <div className="bs5 row mb-1">
                                        <CartSummary summaryFor={Constants.cartSummary.SUBTOTAL} itemLength={totalItems} subTotal={Helper.getFormatNumber(Number(subTotal), currency, symbol)} />
                                    </div>
                                    <div className="bs5 row mb-1">
                                        <div className="col-8"><span className='me-1'>Estimated Shipping:</span>
                                            <Tooltip
                                                opener={() => (<img src={infoCircle} alt='Estimated Shipping' />)}
                                                content={() => ReusableDiv.EstimatedShippingTooltip()}
                                            />
                                        </div>
                                        <div className="col-4 text-end"><b>--</b></div>
                                    </div>
                                    <div className="bs5 row mb-1">
                                        <div className="col-8">Estimated VAT: </div>
                                        <div className="col-4 text-end">
                                            {(!CART_SHIPPING_ADDRESS_ID) &&
                                                <b>--</b>
                                            }
                                            {/* {CART_SHIPPING_ADDRESS_ID && isNumber(vatTotal) && Number(vatTotal) > 0 &&
                                                <b>
                                                    {Helper.getFormatNumber(Number(vatTotal), currency, symbol)}
                                                </b>
                                            } */}
                                        </div>
                                    </div>
                                </div>
                                <div className="bs5 row total-row m-0">
                                    {/* NOTE : LOADER IS PENDING */}
                                    <div className="bs5 row m-0 mini-cart-item-total font_bold_currency">
                                        <div className="col-6 px-0">
                                            <span>
                                                <b>Order Total:</b>
                                            </span>
                                        </div>
                                        <div className="col-6 text-end ps-1">
                                            <span className="subtotal-currency">{currency}  </span>

                                            <span className="font_bold_currency">
                                                {isNumber(subTotal) ? Helper.getFormatNumber(Number(subTotal), currency, symbol, 2, true, false) : ''}</span>
                                        </div>
                                    </div>
                                </div>
                            </>
                        }
                    </>}

            </div >
        </>
    );
}

export default CheckoutTotal;